import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import HeatMapDataController from '../viz_behaviors/HeatMapDataController'
import { encodeDate } from '@/utils/dates.js'

export default class HeatMapViz extends BaseViz {
  static defaultConfig = {
    sizeAttr: null,
    mode: 'grid',

    valueFormat: {
      type: [String, Array, Function, null],
      default: null,
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        showTickValues: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
          exposed: false,
        },
        getExtent: function(data) {
          return data.map(d => d.x)
        },
      },
      y: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
        },
        getExtent: function(data) {
          return data.map(d => d.y)
        },
      },
    },
    minSize: {
      exposed: false,
    },
    maxSize: {
      exposed: false,
    },
    showLabels: {
      nonEditable: true,
      exposed: false,
    },
    ItemsHelper: {
      colorScale: {
        value: 'sequential3',
        options: ['sequential2', 'sequential3'],
      },
      colorKey: 'color',
    },

    TooltipBehavior: {
      getHtml: function(d) {
        let yId = d.id.split('--')[1]?.split('-')[1]
        let date = d.label.split('--')[1]?.split('-')[0]
        let countryName = d.label.split('--')[0]

        if(date===yId) yId=null
        let yString = ''
        if(yId) yString += this.valueWithUnit(yId, 'y') + ' '
        yString += encodeDate(date)
        return `<div class="columns">
          <div class="column"><p class="important">
            ${countryName}
          </p><p>
            ${ yString }
          </p></div>
          <div class="column"><p class="value">
            ${d.color !== null ? this.valueWithUnit(d.color, 'y_1') : '-'}
          </p></div>
        </div>`
      },
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = HeatMapDataController
}
